import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'

const CheckLeniencyAgreements = ({ leniencyAgreementsCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  const hasChecks =
    Array.isArray(leniencyAgreementsCheck?.checkDetails) && leniencyAgreementsCheck.checkDetails.length > 0
  const checkLength = leniencyAgreementsCheck?.checkDetails?.length || 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:leniencyAgreements')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={leniencyAgreementsCheck?.email}
        status={leniencyAgreementsCheck?.status}
        createdAt={leniencyAgreementsCheck?.createdAt}
        updatedAt={leniencyAgreementsCheck?.updatedAt}
      />

      {!Array.isArray(leniencyAgreementsCheck?.checkDetails) && leniencyAgreementsCheck?.checkDetails?.informação && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <Typography variant="subtitle1">{t('common:information')}</Typography>
          <Typography variant="subtitle3">{leniencyAgreementsCheck.checkDetails.informação ?? '---'}</Typography>
        </Paper>
      )}

      {hasChecks &&
        leniencyAgreementsCheck.checkDetails.map((element, index) => (
          <TimelineDotLine key={index}>
            <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:initialDate')}</Typography>
                  <Typography variant="subtitle3">{element.dataInicioAcordo ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:endDate')}</Typography>
                  <Typography variant="subtitle3">{element.dataFimAcordo ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:responsibleBody')}</Typography>
                  <Typography variant="subtitle3">{element.orgaoResponsavel ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:agreementSituation')}</Typography>
                  <Typography variant="subtitle3">{element.situacaoAcordo ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:amount')}</Typography>
                  <Typography variant="subtitle3">{element.quantidade ?? '---'}</Typography>
                </div>
              </div>
            </Paper>
          </TimelineDotLine>
        ))}
    </>
  )
}

export default CheckLeniencyAgreements
